import { useUser } from 'stores/userStore';
import { takeOverUser, releaseUser } from 'stores/userStore';
import styles from 'components/styles/AdminBar.module.scss';
import { ReactNode } from 'react';
import Clickable from '@/components/Clickable';
import TextLink from '@/components/TextLink';
import Close from 'icons/Close';

export default function AdminBar({ user: userProp, children }: { user?: { id: string; username: string }; children?: ReactNode }) {
  const user = useUser();

  if (!user.superUserAccount && !user.isAdmin) return null;

  function handleRelease() {
    releaseUser();
  }

  function handleTakeOver() {
    if (!userProp) return;
    takeOverUser(+userProp.id);
  }

  return (
    <div className={styles.Bar}>
      <div className={styles.User}>
        {user.superUserAccount && (
          <>
            <Clickable onClick={handleRelease}>
              <Close height={12} width={12} color="#fff" />
            </Clickable>
            <span>{`Hello ${user.superUserAccount.first_name}, you are assuming the identity of ${user.account?.username}`}</span>
          </>
        )}
        {userProp && !user.superUserAccount && (
          <TextLink onClick={handleTakeOver}>
            {`Hello, ${user.account?.first_name || user.account?.username}. Click here to become become ${userProp.username}.`}
          </TextLink>
        )}
      </div>
      <div className={styles.Links}>{children}</div>
    </div>
  );
}
